import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

const LoginComponent = () => {
  const navigate = useNavigate();
  const [isPasswordVisible, setPasswordVisible] = useState(false);

  const [isSubmitted, setIsSubmitted] = useState(false);

  const schema = Yup.object().shape({
    email: Yup.string().email()
                      .matches(/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i, 'Email must be a valid email')
                      .required('Email is a required field'),
    password: Yup.string().required(),
  });

  const {register, handleSubmit, formState: { errors, isDirty, isValid } } = useForm({
    mode: "all",
    resolver: yupResolver(schema),
  });

  const onSubmit = async (data) => {
    setIsSubmitted(true);

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      const jsonData = await response.json();

      if (response.ok) {
        localStorage.setItem("token", jsonData.token);
        localStorage.setItem('userInfo', JSON.stringify(jsonData.user));
        
        toast.success(jsonData.message);
        navigate("/dashboard");
        window.location.reload();
      } else {
        toast.error(jsonData.message);
      }
    }
    catch (error) {
      const errorMessage = error.message || "An error occurred";
      toast.error(errorMessage);
    }
    setIsSubmitted(false);
  };

  const handleTogglePassword = () => {
    setPasswordVisible((prevState) => !prevState);
  };

  return (
    <div className="account-page">
      <div className="main-wrapper">
        <div className="account-content">
          <div className="container login_content">
            <div className="account-logo">
              <img src="assets/img/logo.png" alt="Visions" />
            </div>

            <div className="account-box">
              <div className="account-wrapper">
                <h3 className="account-title">Login</h3>
                <p className="account-subtitle">Access to our dashboard</p>

                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className="input-block mb-4">
                    <label className="col-form-label">Email Address</label>
                    <input className="form-control" type="text" {...register("email")} />
                    <div className="form-text text-danger">
                      {errors.email && <p>{errors.email.message}</p>}
                    </div>
                  </div>
                  <div className="input-block mb-4">
                    <div className="row align-items-center">
                      <div className="col">
                        <label className="col-form-label">Password</label>
                      </div>
                    </div>
                    <div className="position-relative">
                      <input className="form-control" type={isPasswordVisible ? "text" : "password"} id="password" {...register("password")} />
                      <span className={`fa-solid ${isPasswordVisible ? "fa-eye" : "fa-eye-slash" }`}
                        onClick={handleTogglePassword} id="toggle-password"></span>
                    </div>
                    <div className="form-text text-danger">
                      {errors.password && <p>{errors.password.message}</p>}
                    </div>
                    <div className="col-auto forgetBtn">
                      <Link className="text-muted" to="/forgot-password">
                        Forgot password?
                      </Link>
                    </div>
                  </div>
                  <div className="input-block mb-4 text-center loginBtn">
                    <button type="submit" disabled={isSubmitted || !isDirty || !isValid}
                      className="btn btn-primary account-btn">
                      Login
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginComponent;
